module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "center-para1"
  }, [_c('a', {
    attrs: {
      "id": "page_i"
    }
  }), _vm._v("P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("RAISE FOR")]), _vm._v(" W"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ALTER")]), _vm._v(" J. B"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OYNE")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“The saga isn’t a new genre, but the aviation saga is—and Walter Boyne invented it. Here’s a first-rate story of the jet age from our foremost aviation writer.”")]), _vm._v(" "), _c('p', {
    staticClass: "right-para"
  }, [_vm._v("—Stephen Coonts on "), _c('em', [_vm._v("Supersonic Thunder")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Boyne packs the novel with historically accurate detail. Aviation fans will gulp this one down in one long, satisfied swallow.”")]), _vm._v(" "), _c('p', {
    staticClass: "right-para"
  }, [_vm._v("—"), _c('em', [_vm._v("Booklist")]), _vm._v(" on "), _c('em', [_vm._v("Roaring Thunder")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Boyne’s narrative follows the story until 1954, incorporating the evolution of the B-52 bomber and the Boeing 707 commercial jet airliner. . . . Boyne doesn’t disappoint.”")]), _vm._v(" "), _c('p', {
    staticClass: "right-para"
  }, [_vm._v("—"), _c('em', [_vm._v("Publishers Weekly")]), _vm._v(" on "), _c('em', [_vm._v("Roaring Thunder")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“"), _c('em', [_vm._v("Dawn Over Kitty Hawk")]), _vm._v(" is an amazing book. Not only is it riveting history, it is also a suspense story that takes readers inside the ferocious competition to be the first in flight.”")]), _vm._v(" "), _c('p', {
    staticClass: "right-para"
  }, [_vm._v("—Thomas Fleming, president of the Society of"), _c('br'), _vm._v("American Historians and "), _c('em', [_vm._v("New York Times")]), _vm._v(" bestselling"), _c('br'), _vm._v("author of "), _c('em', [_vm._v("The Secret Trial of Robert E. Lee")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e949be12","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/frontmatter.vue
// module id = 57
// module chunks = 0